import { render } from "./ClassifyWidget.vue?vue&type=template&id=c8bfe4a2"
import script from "./ClassifyWidget.vue?vue&type=script&lang=js"
export * from "./ClassifyWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__